const wowApp = require('angular').module('wowApp.shop');

//Service

//Directive
wowApp.directive('wowFooter', ['BreakpointsService', require('./footer-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/footer/index.js
 **/